// One slip drawer + its actions (quick view -> edit / issue / cancel / delete / deliver / print) for any page that is not the Dispatches page itself
// (order Deliveries tab, Sales Orders list): the same DispatchDrawer and SlipActionHost the Dispatches page uses, so there is one implementation.
import React, { useState } from 'react';
import DispatchDrawer from './DispatchDrawer';
import SlipActionHost from './SlipActionHost';
import { openDispatchSlipPrint } from '../../../components/documents/printDispatchSlip';
import './Dispatches.css';

export const slipHandlers = (setDrawer, changed) => ({ view: s => setDrawer({ slip: s, mode: 'view' }), edit: s => setDrawer({ slip: s, mode: 'edit' }), issue: s => setDrawer({ slip: s, mode: 'issue' }),
  cancel: s => setDrawer({ slip: s, mode: 'cancel' }), delete: s => setDrawer({ slip: s, mode: 'delete' }), deliver: s => setDrawer({ slip: s, mode: 'deliver' }), print: s => openDispatchSlipPrint(s.slip_id), changed });

// state = { slip, mode } | null ; returns [element, on, setDrawer]
export function useSlipDrawer(onChanged = () => {}) {
  const [drawer, setDrawer] = useState(null);
  const on = slipHandlers(setDrawer, onChanged);
  const el = drawer && (
    <div className="disp-pg" style={{ display: 'contents' }}>
      {drawer.mode === 'view'
        ? <DispatchDrawer key={drawer.slip.slip_id} slip={drawer.slip} onClose={() => setDrawer(null)} on={on} />
        : <SlipActionHost key={`${drawer.slip.slip_id}:${drawer.mode}`} slip={drawer.slip} mode={drawer.mode} onClose={() => setDrawer(null)} onChanged={onChanged} />}
    </div>);
  return [el, on, setDrawer];
}
